import type { CoreApiClient } from "../client";
import { createRoomMutations } from "../mutations/room.mutations";
import { createRoomQueries } from "../queries/room.queries";

export const createRoomRepository = (api: CoreApiClient) => ({
  ...createRoomQueries(api),
  ...createRoomMutations(api),
});
